import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classNames from 'classnames';

export default class HideOOSCheckLink extends PureComponent {
  static propTypes = {
    checked: PropTypes.bool.isRequired,
    link: PropTypes.string.isRequired,
  };

  render() {
    const { link, checked } = this.props;

    return (
      <div className={classNames('hideoos-checklink', { checked })}>
        <Link
          className="hideoos-checklink__link"
          to={link}
        >
          Hide out of stock items you haven&apos;t bought before
        </Link>
      </div>
    );
  }
}
